import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:0830b1f8-fb03-4e11-a7fc-4031a9cff9f2",
    aws_user_pools_id: "ap-southeast-2_kuSau3hQg",
    aws_user_pools_web_client_id: "5k0alfhjca5atstbabvodf1kl9",
    Auth: {
      identityPoolId: "ap-southeast-2:0830b1f8-fb03-4e11-a7fc-4031a9cff9f2",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_kuSau3hQg",
      userPoolWebClientId: "5k0alfhjca5atstbabvodf1kl9",
    },
    oauth: {
      domain: "whs-safer-prod-sg.auth.ap-southeast-2.amazoncognito.com",
      redirectSignIn: "https://prod.sg.safer.whs.amazon.dev",
      redirectSignOut: "https://prod.sg.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
